module.exports = __webpack_public_path__ + "static/media/thumb-vfb.0c6b893e.svg";